import fetch from "isomorphic-fetch";
import API_URL from "helpers/apiURL";

const fetchParameters = (dispatch) => {
  fetch(`https://territorioyacopini.com.ar/api/v2/used/parameters`)
    .then((response) => response.json())
    .then((json) => dispatch(receiveParameters(json)))
    .catch((e) => {
      console.log(e);
    });
};

const fetchPromotions = (dispatch) => {
  fetch(`https://territorioyacopini.com.ar/api/used-promotion/discover`)
    .then((response) => response.json())
    .then((json) => dispatch(receivePromotions(json)))
    .catch((e) => {
      console.log(e);
    });
};

const fetchStories = (dispatch) => {
  fetch(`https://territorioyacopini.com.ar/api/v2/used/stories`)
    .then((response) => response.json())
    .then((json) => dispatch(receiveStories(json.data)))
    .catch((e) => {
      console.log(e);
    });
};

export const fetchStock = () => {
  return function (dispatch) {
    dispatch(requestStock());

    fetchParameters(dispatch);
    fetchPromotions(dispatch);
    fetchStories(dispatch);

    return fetch(`${API_URL}/used/vehicle`)
      .then((response) => response.json())
      .then((json) => dispatch(receiveStock(json)))
      .catch((e) => {
        console.log(e);
        dispatch(requestStockFailed());
      });
  };
};

export const fetchStockItem = (id) => {
  return function (dispatch) {
    dispatch(requestStockItem());

    fetchPromotions(dispatch);

    return fetch(`${API_URL}/used/vehicle/${id}`)
      .then((response) => response.json())
      .then((json) => dispatch(receiveStockItem(json)))
      .catch((e) => {
        console.log(e);
        dispatch(requestStockItemFailed());
      });
  };
};

export const requestStock = () => ({ type: "REQUEST_STOCK" });

export const requestStockFailed = () => ({ type: "REQUEST_STOCK_FAILED" });

export const receiveStock = (response) => ({
  type: "RECEIVE_STOCK",
  items: response.data,
});

export const receiveStories = (stories = []) => ({
  type: "RECEIVE_STORIES",
  items: stories,
});

export const filterStock = (filter, value) => ({
  type: "FILTER_STOCK",
  filter,
  value,
});

export const requestStockItem = () => ({ type: "REQUEST_STOCK_ITEM" });

export const requestStockItemFailed = () => ({
  type: "REQUEST_STOCK_ITEM_FAILED",
});

export const receiveStockItem = (response) => ({
  type: "RECEIVE_STOCK_ITEM",
  item: response.data,
});

export const receivePromotions = (response) => ({
  type: "RECEIVE_PROMOTION_CODES",
  payload: response.data,
});

export const receiveParameters = (response) => ({
  type: "RECEIVE_PARAMETERS",
  payload: response.data,
});
